module.exports = __webpack_public_path__ + "static/media/banderitasDesktop.6a7abc43.svg";